import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ImageViewerModel } from "../../models/ImageViewerModel";
import { ContractService } from "../../services/contract.service";

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css']
})
export class ImageViewerComponent implements OnInit {
  public imageDetails: ImageViewerModel
  constructor(private dialogRef: MatDialogRef<ImageViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImageViewerModel,
   
    public contractService: ContractService) {
    this.imageDetails = data ? data : new ImageViewerModel();

  }

  ngOnInit(): void {
  }

}
